var swiper = new Swiper(".collection-related-products", {
      speed: 400,
      spaceBetween: 10,
      slidesPerView: 2,
      loop: true,
      simulateTouch: true,
      allowTouchMove: true,
      navigation: {
        nextEl: ".collection-rp-next",
        prevEl: ".collection-rp-prev",
      },
      breakpoints: {
        // when window width is >= 640px
        768: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      }
    });